// extracted by mini-css-extract-plugin
export default {"container":"ProductList_container__ifw33","wrapper":"ProductList_wrapper__YETCL","cards":"ProductList_cards__o3Gou","totalCard":"ProductList_totalCard__Pot3L"};